export default "/fonts/vendor/katex/dist/KaTeX_Main-Regular.ttf?9eba1d77abcf2aa6e94e823d52be546b";